import { useParams, useMatch } from 'react-router-dom-v5-compat'

import { capitalize } from '~publish/helpers/capitalize'
import { useQueryParam } from '~publish/hooks/useQueryParam'
import {
  allChannels,
  tagTab,
  profileTabPages,
  channel,
} from '~publish/legacy/routes'

export const useNotesCtaView = (): string => {
  const { tabId, tab } = useParams<{
    tabId?: string
    tab?: string
  }>()
  const [queryTab] = useQueryParam('tab')
  const isAllChannelsPage = !!useMatch(allChannels.route)
  const isChannelPage = !!useMatch(channel.route)
  const isTagsPage = useMatch(tagTab.route)
  const isProfilePage = !!useMatch(profileTabPages.route)

  if (isAllChannelsPage) {
    return `allChannels${capitalize(queryTab || 'queue')}`
  }

  if (isChannelPage) {
    return `channel${capitalize(queryTab || 'queue')}`
  }

  if (isTagsPage && tab) {
    return `tags${capitalize(tab)}`
  }

  if (isProfilePage && tabId) {
    return `profile${capitalize(tabId)}`
  }

  return 'unknown'
}
